import React from 'react';

const CourseSelection = () => {
    return (
        <div class="hero mt-20 mb-16 bg-slate-100 ">
        <div class="hero-content flex-col lg:flex-row mt-14 mb-16">
          <img src="https://i.ibb.co/LQ99PwP/Frame-29.png" class="admission" />
          <div>
          <div className='justify-center'>
                  <h1 class="text-start lg:ml-36 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">Course Selection <span className='text-secondary'>and Admission Advice</span> </h1>
               
                  <p class="mt-12 text-lg text-justify lg:w-10/12 lg:ml-28">Generation Abroad believes every student profile is unique, so we carefully evaluate each profile, including past education qualifications and professional experience through recognition of prior learning (RPL). We choose the ideal school for each applicant and produce the accompanying documents after extensive study. A student with a study hiatus of more than two years after graduating from high school or college must give acceptable documentation for the gap. Again, applicants must justify their choice of course in the statement of purpose. Luckily, we can help students with this. After assessing interests, academic history, financial status, and professional ambitions, our dedicated counselors propose the right course and school..</p>
               
                </div>
          </div>
        </div>
      </div>
    );
};

export default CourseSelection;